import React from "react";
import "./Header.css";
import "materialize-css";
import { Navbar, Icon } from "react-materialize";

export default function Header() {
    return (
        <Navbar alignLinks="right" brand={<a className="brand-logo blue-grey-text text-lighten-5" href="#">ZP</a>} className="navbar" menuIcon={<Icon>menu</Icon>} centerChildren />
    )
}